import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
// import Cookies from 'js-cookie'
import store from './store'
Vue.prototype.$store = store
// import videojs from 'video.js'
// Vue.prototype.$videoJS = videojs;
// 1.全局引用
// import VideoPlayer from 'vue-video-player'
// import 'vue-video-player/src/custom-theme.css'
// import 'video.js/dist/video-js.css'
// Vue.use(VideoPlayer)

// import { Carousel, CarouselItem, Select,Option,Input,Dropdown,DropdownMenu,DropdownItem,Image,Icon,Table,TableColumn,Checkbox,Pagination,Dialog,Popover} from 'element-ui'
// Vue.use(Carousel).use(CarouselItem).use(Select).use(Option).use(Input).use(Dropdown).use(DropdownMenu).use(Table).use(TableColumn).use(Checkbox).use(Dialog).use(Popover).use(Pagination).use(Icon).use(Image).use(DropdownItem)
import ElementUi from 'element-ui';             //全局引入element
import 'element-ui/lib/theme-chalk/index.css';    //全局引入element的样式
Vue.use(ElementUi); //2.使用
import axios from 'axios' //导入axios
Vue.prototype.$axios = axios //修改原始数据
import * as filters from '@/utils/filter'//引入全局filter
Vue.prototype.$filters = filters
// 瀑布
// 底部
import indexTab from "@/components/indexTab"
import bot from "@/components/bot"
import tabRight from "@/components/tabRight"
Vue.component('indexTab', indexTab)
Vue.component('bot', bot)
Vue.component('tabRight', tabRight)

Vue.config.productionTip = false


// 全局挂载
// Vue.use(VueAwesomeSwiper)
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// import { swiper, swiperSlide } from "vue-awesome-swiper";
// import "swiper/dist/css/swiper.css";
// 全局挂载
// Vue.use(VueAwesomeSwiper)

// import { download } from '@/assets/js/request'
// Vue.prototype.download = download;
// import { setBaseUrl,getBaseUrl } from '@/utils/auth'
// setBaseUrl('http://192.168.22.220:9080');
// setBaseUrl('http://192.168.22.220:9080');
// console.log('ddd:',getBaseUrl());
// Vue.prototype.getBaseUrl = getBaseUrl;
// echarts
// import * as echarts from 'echarts';
// Vue.prototype.$echarts = echarts
// Vue.use(Element, {
//   size: Cookies.get('size') || 'medium' // set element-ui default size
// })
// import VueQrcode from 'vue-qrcode'
// Vue.component('vue-qrcode', VueQrcode)
new Vue({
  router,
  render: h => h(App),
  store,
  //  created() {
    // const meta = document.createElement('meta');
    // meta.httpEquiv = 'Content-Security-Policy';
    // meta.content = 'upgrade-insecure-requests';
    // document.head.appendChild(meta);
  // }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js